<template>
  <div
    class="py-2 transition-colors hover:bg-gray-50 text-sm text-gray-500 px-4 flex justify-between items-start overflow-hidden min-w-0 draggable-source"
  >
    <slot></slot>
  </div>
</template>
